export enum EntityStatus {
  ACTIVE = 'active',
  DRAFT = 'draft',
  DEACTIVATED = 'deactivated',
  DELETED = 'deleted',
}

export enum EntityDeletionReason {
  USER_REQUEST = 'user_request',
  ADMIN_ACTION = 'admin_action',
  SECURITY_REASON = 'security_reason',
}
